module.exports = __webpack_public_path__ + "assets/img/teacher (41).9c8119df.png";